import React from 'react';
import Navbartask from '../components/Navbartask';
import Taskboard from '../components/Taskboard'; // adjust path if needed
import '../css/main.css'


const Taskpages = () => {
  return (
    <div className="container-dash bg-gray-50 min-h-screen">
      <Navbartask />
      <Taskboard />
    </div>
  );
};

export default Taskpages;